import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [{
  path: '/migrasi',
  name: 'Migrasi',
  component: () => import( /* webpackChunkName: "Migrasi" */ '../views/migrasi/Migrate.vue'),
  meta: {
    title: 'Migrasi dari V2',
    auth: false
  }
},
{
  path: '/order',
  name: 'OrderPublic',
  component: () => import( /* webpackChunkName: "Order" */ '../views/OrderPublic.vue'),
  meta: { title: 'Pesan Paket', auth: false, public: true }
},
{
  path: '/order/:id',
  name: 'OrderPublicPkg',
  component: () => import( /* webpackChunkName: "Order" */ '../views/OrderPublic.vue'),
  meta: { title: 'Pesan Paket', auth: false, public: true }
},
{
  path: '/login',
  name: 'Login',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/Login.vue'),
  meta: {
    title: 'Login',
    auth: false,
  }
},
{
  path: '/login-cs',
  name: 'LoginCustomerService',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/LoginCustomerService.vue'),
  meta: {
    title: 'Login',
    auth: false
  }
},
{
  path: '/register',
  name: 'Register',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/Register.vue'),
  meta: {
    title: 'Register',
    auth: false
  }
},
{
  path: '/verify',
  name: 'Verify',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/Verify.vue'),
  meta: {
    title: 'Verify',
    auth: false
  }
},
{
  path: '/reset-password',
  name: 'ResetPassword',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/ResetPassword.vue'),
  meta: {
    title: 'Reset Password',
    auth: false
  }
},
{
  path: '/dashboard',
  alias: ['/'],
  name: 'Dashboard',
  component: () => import( /* webpackChunkName: "Home" */ '../views/home/Dashboard.vue'),
  meta: {
    title: 'Dashboard',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/profile',
  name: 'Profile',
  component: () => import( /* webpackChunkName: "Data" */ '../views/profile/Profile.vue'),
  meta: {
    title: 'Profile',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency']
  }
},
{
  path: '/contact',
  name: 'Contact',
  component: () => import( /* webpackChunkName: "Data" */ '../views/data/Contact.vue'),
  meta: {
    title: 'Contact',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},

{
  path: '/contact-labels',
  name: 'ContactLabel',
  component: () => import( /* webpackChunkName: "Data" */ '../views/data/ContactLabel.vue'),
  meta: {
    title: 'Label Kontak',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/contact/edit',
  name: 'EditContact',
  component: () => import( /* webpackChunkName: "Data" */ '../views/data/EditContact.vue'),
  meta: {
    title: 'Contact',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/group',
  name: 'Group',
  component: () => import( /* webpackChunkName: "Data" */ '../views/data/Group.vue'),
  meta: {
    title: 'Contact Group',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/group/edit',
  name: 'EditGroup',
  component: () => import( /* webpackChunkName: "Data" */ '../views/data/EditGroup.vue'),
  meta: {
    title: 'Contact Group',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/daily-leads',
  name: 'DailyLeads',
  component: () => import( /* webpackChunkName: "Data" */ '../views/daily-leads/index.vue'),
  meta: {
    title: 'Daily Leads',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/daily-leads/:id',
  name: 'DailyLeadsDetail',
  component: () => import( /* webpackChunkName: "Data" */ '../views/daily-leads/detail.vue'),
  meta: {
    title: 'Daily Leads',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/lynk-integration',
  name: 'LynkIntegration',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/lynk/Index.vue'),
  meta: {
    title: 'Integrasi Lynk.id',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/mayar-integration',
  name: 'MayarIntegration',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/mayar/Index.vue'),
  meta: {
    title: 'Integrasi Mayar.id',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/mayar-integration/:id/logs',
  name: 'MayarLogs',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/mayar/Logs.vue'),
  meta: {
    title: 'Webhook Log Mayar',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/mayar-integration/:id/event-templates',
  name: 'MayarEventTemplates',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/mayar/EventTemplates.vue'),
  meta: {
    title: 'Template Event Mayar',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/send',
  name: 'Send',
  component: () => import( /* webpackChunkName: "Outgoing" */ '../views/outgoing/Send.vue'),
  meta: {
    title: 'Send Message',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/outgoing',
  name: 'Outgoing',
  component: () => import( /* webpackChunkName: "Outgoing" */ '../views/outgoing/Outgoing.vue'),
  meta: {
    title: 'Outgoing',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/outgoing/detail',
  name: 'OutgoingDetail',
  component: () => import( /* webpackChunkName: "Outgoing" */ '../views/outgoing/Detail.vue'),
  meta: {
    title: 'Outgoing',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/blast-list',
  name: 'BlastList',
  component: () => import( /* webpackChunkName: "BlastList" */ '../views/blast_list/BlastList.vue'),
  meta: {
    title: 'Blast List',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/blast-list/create',
  name: 'BlastListCreate',
  component: () => import( /* webpackChunkName: "BlastList" */ '../views/blast_list/Create.vue'),
  meta: {
    title: 'Create Blast List',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/blast-list/edit',
  name: 'BlastListEdit',
  component: () => import( /* webpackChunkName: "BlastList" */ '../views/blast_list/Edit.vue'),
  meta: {
    title: 'Edit Blast List',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/blast-list/detail',
  name: 'BlastListDetail',
  component: () => import( /* webpackChunkName: "BlastList" */ '../views/blast_list/Detail.vue'),
  meta: {
    title: 'Blast List Detail',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/broadcast',
  name: 'Broadcast',
  component: () => import( /* webpackChunkName: "Outgoing" */ '../views/broadcast/Broadcast.vue'),
  meta: {
    title: 'Broadcast',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/incoming',
  name: 'Incoming',
  component: () => import( /* webpackChunkName: "Incoming" */ '../views/incoming/Incoming.vue'),
  meta: {
    title: 'Incoming',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/incoming/detail',
  name: 'IncomingDetail',
  component: () => import( /* webpackChunkName: "Incoming" */ '../views/incoming/Detail.vue'),
  meta: {
    title: 'Incoming',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/autoreply',
  name: 'Autoreply',
  component: () => import( /* webpackChunkName: "Autoreply" */ '../views/autoreply/Autoreply.vue'),
  meta: {
    title: 'Autoreply',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/autoreply/add',
  name: 'AddAutoreply',
  component: () => import( /* webpackChunkName: "Autoreply" */ '../views/autoreply/Add.vue'),
  meta: {
    title: 'Autoreply',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/autoreply/detail',
  name: 'DetailAutoreply',
  component: () => import( /* webpackChunkName: "Autoreply" */ '../views/autoreply/Detail.vue'),
  meta: {
    title: 'Autoreply',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
// Birthday Module
{
  path: '/birthday',
  name: 'BirthdayList',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayList.vue'),
  meta: {
    title: 'Daftar Ulang Tahun',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/template',
  name: 'BirthdayTemplate',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayTemplate.vue'),
  meta: {
    title: 'Template Ucapan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/template/add',
  name: 'BirthdayTemplateAdd',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayTemplateAdd.vue'),
  meta: {
    title: 'Tambah Template Ucapan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/template/edit',
  name: 'BirthdayTemplateEdit',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayTemplateEdit.vue'),
  meta: {
    title: 'Edit Template Ucapan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/settings',
  name: 'BirthdaySettings',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdaySettings.vue'),
  meta: {
    title: 'Pengaturan Ulang Tahun',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/stats',
  name: 'BirthdayStats',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayStats.vue'),
  meta: {
    title: 'Statistik & Laporan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/birthday/import',
  name: 'BirthdayImport',
  component: () => import( /* webpackChunkName: "Birthday" */ '../views/birthday/BirthdayImport.vue'),
  meta: {
    title: 'Import Data Pelanggan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
// Follow Up Otomatis Module
{
  path: '/follow-up',
  name: 'FollowUpList',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpList.vue'),
  meta: {
    title: 'Daftar Follow Up',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/add',
  name: 'FollowUpAdd',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpAdd.vue'),
  meta: {
    title: 'Buat Follow Up Baru',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/edit',
  name: 'FollowUpEdit',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpEdit.vue'),
  meta: {
    title: 'Edit Follow Up',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/template',
  name: 'FollowUpTemplate',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpTemplate.vue'),
  meta: {
    title: 'Template Pesan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/template/add',
  name: 'FollowUpTemplateAdd',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpTemplateAdd.vue'),
  meta: {
    title: 'Tambah Template Pesan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/template/edit',
  name: 'FollowUpTemplateEdit',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpTemplateEdit.vue'),
  meta: {
    title: 'Edit Template Pesan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/stats',
  name: 'FollowUpStats',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpStats.vue'),
  meta: {
    title: 'Statistik & Laporan',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/contact-history',
  name: 'FollowUpContactHistory',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpContactHistory.vue'),
  meta: {
    title: 'Riwayat Follow Up Kontak',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/import',
  name: 'FollowUpImport',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpImport.vue'),
  meta: {
    title: 'Import Kontak Follow Up',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/follow-up/settings',
  name: 'FollowUpSettings',
  component: () => import( /* webpackChunkName: "FollowUp" */ '../views/followup/FollowUpSettings.vue'),
  meta: {
    title: 'Pengaturan Follow Up',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/invoice',
  name: 'InvoiceList',
  component: () => import(/* webpackChunkName: "Invoice" */ '../views/invoice/InvoiceList.vue'),
  meta: { title: 'Invoice', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/invoice/create',
  name: 'InvoiceCreate',
  component: () => import(/* webpackChunkName: "Invoice" */ '../views/invoice/InvoiceForm.vue'),
  meta: { title: 'Buat Invoice', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/invoice/customers',
  name: 'InvoiceCustomers',
  component: () => import(/* webpackChunkName: "Invoice" */ '../views/invoice/InvoiceCustomers.vue'),
  meta: { title: 'Customer Invoice', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/invoice/settings',
  name: 'InvoiceSettings',
  component: () => import(/* webpackChunkName: "Invoice" */ '../views/invoice/InvoiceSettings.vue'),
  meta: { title: 'Pengaturan Invoice', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/invoice/:id',
  name: 'InvoiceDetail',
  component: () => import(/* webpackChunkName: "Invoice" */ '../views/invoice/InvoiceDetail.vue'),
  props: route => ({ id: route.params.id }),
  meta: { title: 'Detail Invoice', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/inv/:token',
  name: 'PublicInvoice',
  component: () => import(/* webpackChunkName: "InvoicePublic" */ '../views/public/PublicInvoice.vue'),
  meta: { title: 'Invoice', public: true }
},
{
  path: '/google-form-generator',
  name: 'GoogleFormGenerator',
  component: () => import( /* webpackChunkName: "GoogleScriptGenerator" */ '../views/google/GoogleForm.vue'),
  meta: {
    title: 'Google Form',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/google-spreadsheet-generator',
  name: 'GoogleSpreadsheetGenerator',
  component: () => import( /* webpackChunkName: "GoogleScriptGenerator" */ '../views/google/GoogleSpreadsheet.vue'),
  meta: {
    title: 'Google Spreadsheet',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/web-whatsapp',
  name: 'WebWhatsapp',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/chat/SelectDevice.vue'),
  meta: {
    title: 'Web Whatsapp',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/web-whatsapp/:id',
  name: 'WebWhatsapp',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/chat/Chat.vue'),
  meta: {
    title: 'Web Whatsapp',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
    fullscreen: true,
  }
},
{
  path: '/customer-service',
  name: 'CustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/cs/CustomerService.vue'),
  meta: {
    title: 'Customer Service',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/customer-service/detail',
  name: 'CustomerServiceDetail',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/cs/Detail.vue'),
  meta: {
    title: 'Customer Service',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/chat-widget',
  name: 'ChatWidget',
  component: () => import( /* webpackChunkName: "ChatWidget" */ '../views/chat_widget/ChatWidget.vue'),
  meta: {
    title: 'Chat Widget',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/chat-widget/detail',
  name: 'ChatWidgetDetail',
  component: () => import( /* webpackChunkName: "ChatWidget" */ '../views/chat_widget/Detail.vue'),
  meta: {
    title: 'Chat Widget',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/campaign',
  name: 'Campaign',
  component: () => import( /* webpackChunkName: "Campaign" */ '../views/campaign/Campaign.vue'),
  meta: {
    title: 'Campaign',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/campaign/detail',
  name: 'CampaignDetail',
  component: () => import( /* webpackChunkName: "Campaign" */ '../views/campaign/Detail.vue'),
  meta: {
    title: 'Campaign',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop',
  name: 'ShopList',
  component: () => import( /* webpackChunkName: "Shop" */ '../views/shop/ShopList.vue'),
  meta: {
    title: 'Shop',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop/tutorial',
  name: 'ShopTutorial',
  component: () => import( /* webpackChunkName: "Shop" */ '../views/shop/ShopTutorial.vue'),
  meta: {
    title: 'Tutorial Online Shop',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop/:id',
  name: 'ShopDetail',
  component: () => import( /* webpackChunkName: "Shop" */ '../views/shop/ShopDetail.vue'),
  meta: {
    title: 'Shop Detail',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop/:shopId/products',
  name: 'ShopProducts',
  component: () => import( /* webpackChunkName: "Shop" */ '../views/shop/ProductList.vue'),
  meta: {
    title: 'Shop Products',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop/:shopId/orders',
  name: 'ShopOrders',
  component: () => import( /* webpackChunkName: "Shop" */ '../views/shop/OrderList.vue'),
  meta: {
    title: 'Shop Orders',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/shop/:id/dashboard',
  name: 'ShopDashboard',
  component: () => import('../views/shop/Dashboard.vue'),
  meta: { title: 'Dashboard Toko', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/templates',
  name: 'ShopTemplates',
  component: () => import('../views/shop/Templates.vue'),
  meta: { title: 'Template Pesan', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/categories',
  name: 'ShopCategories',
  component: () => import('../views/shop/Categories.vue'),
  meta: { title: 'Kategori Produk', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/settings',
  name: 'ShopSettings',
  component: () => import('../views/shop/Settings.vue'),
  meta: { title: 'Setting Toko', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/broadcast',
  name: 'ShopBroadcast',
  component: () => import('../views/shop/Broadcast.vue'),
  meta: { title: 'Broadcast Produk', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop-balance',
  name: 'ShopBalance',
  component: () => import('../views/shop/Balance.vue'),
  meta: { title: 'Saldo Toko', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/order/:id',
  name: 'ShopOrderDetail',
  component: () => import('../views/shop/OrderDetail.vue'),
  meta: { title: 'Detail Order', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/reports',
  name: 'ShopReports',
  component: () => import('../views/shop/Reports.vue'),
  meta: { title: 'Laporan Penjualan', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/shop/:id/notification-log',
  name: 'ShopNotificationLog',
  component: () => import('../views/shop/NotificationLog.vue'),
  meta: { title: 'Log Notifikasi', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/admin/shop-withdrawals',
  name: 'AdminShopWithdrawals',
  component: () => import('../views/admin/AdminShopWithdrawals.vue'),
  meta: { title: 'Tarik Saldo Toko (Admin)', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/balance-transfer',
  name: 'AdminBalanceTransfer',
  component: () => import('../views/admin/AdminBalanceTransfer.vue'),
  meta: { title: 'Transfer Saldo (Admin)', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/online-shops',
  name: 'AdminOnlineShops',
  component: () => import('../views/admin/AdminOnlineShops.vue'),
  meta: { title: 'Online Shop (Admin)', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/produk/:slug',
  name: 'PublicProductLink',
  component: () => import('../views/public/PublicProductLink.vue'),
  meta: { title: 'Produk', public: true }
},
// PUBLIC SHOP CATALOG (no auth — accessible even when logged in)
{
  path: '/toko/:slug',
  name: 'PublicShopCatalog',
  component: () => import('../views/public/ShopCatalog.vue'),
  meta: { title: 'Toko', public: true }
},
{
  path: '/toko/:slug/produk/:productSlug',
  name: 'PublicShopProductDetail',
  component: () => import('../views/public/ShopProductDetail.vue'),
  meta: { title: 'Produk', public: true }
},
{
  path: '/toko/:slug/keranjang',
  name: 'PublicShopCart',
  component: () => import('../views/public/ShopCart.vue'),
  meta: { title: 'Keranjang', public: true }
},
{
  path: '/toko/:slug/checkout',
  name: 'PublicShopCheckout',
  component: () => import('../views/public/ShopCheckout.vue'),
  meta: { title: 'Checkout', public: true }
},
{
  path: '/shop/:id/donations',
  name: 'ShopDonationList',
  component: () => import('../views/shop/ShopDonationList.vue'),
  meta: { title: 'Daftar Donasi', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/toko/:slug/donasi',
  name: 'PublicShopDonation',
  component: () => import('../views/public/ShopDonation.vue'),
  meta: { title: 'Donasi', public: true }
},
{
  path: '/toko/:slug/donasi/:donationNumber',
  name: 'PublicShopDonationSuccess',
  component: () => import('../views/public/ShopDonationSuccess.vue'),
  meta: { title: 'Donasi', public: true }
},
{
  path: '/shop/:id/lms/enrollments',
  name: 'ShopLMSEnrollments',
  component: () => import('../views/shop/EnrollmentList.vue'),
  meta: { title: 'Daftar Siswa LMS', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: true }
},
{
  path: '/toko/:slug/kursus',
  name: 'PublicShopLMSCatalog',
  component: () => import('../views/public/ShopLMSCatalog.vue'),
  meta: { title: 'Katalog Kursus', public: true }
},
{
  path: '/toko/:slug/kursus/:courseSlug',
  name: 'PublicShopCourseDetail',
  component: () => import('../views/public/ShopCourseDetail.vue'),
  meta: { title: 'Detail Kursus', public: true }
},
{
  path: '/toko/:slug/kursus/:courseSlug/belajar',
  name: 'PublicShopCourseLearn',
  component: () => import('../views/public/ShopCourseLearn.vue'),
  meta: { title: 'Belajar', public: true }
},
{
  path: '/toko/:slug/kursus/:courseSlug/enroll/:enrollmentNumber',
  name: 'PublicShopCourseEnrollSuccess',
  component: () => import('../views/public/ShopCourseEnrollSuccess.vue'),
  meta: { title: 'Enrollment Kursus', public: true }
},
{
  path: '/toko/:slug/order/:orderId',
  name: 'PublicShopOrderSuccess',
  component: () => import('../views/public/ShopOrderSuccess.vue'),
  meta: { title: 'Order', public: true }
},
{
  path: '/toko/:slug/member/login',
  name: 'PublicShopMemberLogin',
  component: () => import('../views/public/ShopMemberLogin.vue'),
  meta: { title: 'Login Member', public: true }
},
{
  path: '/toko/:slug/member/forgot-password',
  name: 'PublicShopMemberForgotPassword',
  component: () => import('../views/public/ShopMemberForgotPassword.vue'),
  meta: { title: 'Lupa Password', public: true }
},
{
  path: '/toko/:slug/member/reset-password',
  name: 'PublicShopMemberResetPassword',
  component: () => import('../views/public/ShopMemberResetPassword.vue'),
  meta: { title: 'Reset Password', public: true }
},
{
  path: '/toko/:slug/member/dashboard',
  name: 'PublicShopMemberDashboard',
  component: () => import('../views/public/ShopMemberDashboard.vue'),
  meta: { title: 'Portal Member', public: true }
},
/*{
  path: '/order-online',
  name: 'OrderOnline',
  component: () => import( /* webpackChunkName: "OrderOnline" *//* '../views/orderonline/OrderOnline.vue'),
meta: {
  title: 'Order Online',
  auth: true,
  role: ['admin', 'user', 'agency', 'user-agency'],
  expiredGuard: true,
}
},*/
{
  path: '/order-online/detail',
  name: 'OrderOnlineDetail',
  component: () => import( /* webpackChunkName: "OrderOnline" */ '../views/orderonline/Detail.vue'),
  meta: {
    title: 'Order Online',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/link-rotator',
  name: 'LinkRotator',
  component: () => import( /* webpackChunkName: "LinkRotator" */ '../views/linkrotator/LinkRotator.vue'),
  meta: {
    title: 'Link Rotator',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/link-rotator/create',
  name: 'LinkRotatorCreate',
  component: () => import( /* webpackChunkName: "LinkRotator" */ '../views/linkrotator/Create.vue'),
  meta: {
    title: 'Link Rotator',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/link-rotator/detail',
  name: 'LinkRotatorDetail',
  component: () => import( /* webpackChunkName: "LinkRotator" */ '../views/linkrotator/Detail.vue'),
  meta: {
    title: 'Link Rotator',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/group-greeter',
  name: 'GroupGreeter',
  component: () => import( /* webpackChunkName: "GroupGreeter" */ '../views/groupgreeter/GroupGreeter.vue'),
  meta: {
    title: 'Group Greeter',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/group-greeter/detail',
  name: 'GroupGreeterDetail',
  component: () => import( /* webpackChunkName: "GroupGreeter" */ '../views/groupgreeter/Detail.vue'),
  meta: {
    title: 'Group Greeter',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/documentation',
  name: 'Documentation',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/integration/Documentation.vue'),
  meta: {
    title: 'Documentation',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/webhook',
  name: 'Webhook',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/integration/Webhook.vue'),
  meta: {
    title: 'Webhook',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/dedicated-chat-gpt',
  name: 'DedicatedChatGPT',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/chatgpt/dedicated/ChatGPT.vue'),
  meta: {
    title: 'ChatGPT',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/dedicated-chat-gpt/detail',
  name: 'DedicatedChatGPT',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/chatgpt/dedicated/ChatGPTDetail.vue'),
  meta: {
    title: 'ChatGPT Detail',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/chat-gpt',
  name: 'ChatGPT',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/chatgpt/sharing/ChatGPT.vue'),
  meta: {
    title: 'ChatGPT',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/chat-gpt/detail',
  name: 'ChatGPT',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/chatgpt/sharing/ChatGPTDetail.vue'),
  meta: {
    title: 'ChatGPT Detail',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/chat-gpt/providers',
  name: 'ChatGPTProviders',
  component: () => import( /* webpackChunkName: "Integration" */ '../views/chatgpt/provider/Provider.vue'),
  meta: {
    title: 'ChatGPT Providers',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/device',
  name: 'Device',
  component: () => import( /* webpackChunkName: "Device" */ '../views/device/Device.vue'),
  meta: {
    title: 'Device',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/device/edit',
  name: 'EditDevice',
  component: () => import( /* webpackChunkName: "Device" */ '../views/device/EditDevice.vue'),
  meta: {
    title: 'Device',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/device/scan',
  name: 'ScanDevice',
  component: () => import( /* webpackChunkName: "Device" */ '../views/device/Scan.vue'),
  meta: {
    title: 'Device',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
    expiredGuard: true,
  }
},
{
  path: '/billing',
  name: 'Billing',
  component: () => import( /* webpackChunkName: "Billing" */ '../views/billing/Billing.vue'),
  meta: {
    title: 'Billing',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency']
  }
},
{
  path: '/billing/buy/:id',
  name: 'BillingBuy',
  component: () => import( /* webpackChunkName: "Billing" */ '../views/billing/Buy.vue'),
  meta: {
    title: 'Billing',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency']
  }
},
{
  path: '/billing/transaction',
  name: 'BillingTransaction',
  component: () => import( /* webpackChunkName: "Billing" */ '../views/billing/Transaction.vue'),
  meta: {
    title: 'Billing',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency']
  }
},
{
  path: '/agency/users',
  name: 'UsersAgency',
  component: () => import( /* webpackChunkName: "Agency" */ '../views/agency/Users.vue'),
  meta: {
    title: 'Agency Page',
    auth: true,
    role: ['agency'],
    expiredGuard: true,
  }
},
{
  path: '/agency/users/edit',
  name: 'EditUserAgency',
  component: () => import( /* webpackChunkName: "Agency" */ '../views/agency/EditUser.vue'),
  meta: {
    title: 'Agency Page',
    auth: true,
    role: ['agency'],
    expiredGuard: true,
  }
},
{
  path: '/admin/laporan',
  name: 'Laporan',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Laporan.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/statistics',
  name: 'Statistics',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Statistics.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/device-diskonek',
  name: 'DeviceDiskonek',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/DeviceDiskonek.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/device-connection',
  name: 'DeviceConnection',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/DeviceConnection.vue'),
  meta: {
    title: 'Koneksi Device',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/pengaturan',
  name: 'Pengaturan',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Pengaturan.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/paket',
  name: 'Paket',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Paket.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/paket/edit',
  name: 'EditPaket',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/EditPaket.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/users',
  name: 'ListUser',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Users.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/agency',
  name: 'ListAgency',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Agency.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/users/edit',
  name: 'EditUser',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/EditUser.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/message-template',
  name: 'MessageTemplate',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/MessageTemplate.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/notification-log',
  name: 'AdminNotificationLog',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/NotificationLog.vue'),
  meta: {
    title: 'Notification Log',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
/* __TELEGRAM_ROUTE__ */
{
  path: '/admin/telegram-setup',
  name: 'AdminTelegramSetup',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/TelegramSetup.vue'),
  meta: {
    title: 'Telegram Bot Setup',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
/* __MANUAL_PAYMENT_ROUTES__ */
{
  path: '/admin/payment-setting',
  name: 'AdminPaymentSetting',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/PaymentSetting.vue'),
  meta: {
    title: 'Payment Setting',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/manual-payments',
  name: 'AdminManualPaymentQueue',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/ManualPaymentQueue.vue'),
  meta: {
    title: 'Manual Payment Queue',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/billing/manual-payments',
  name: 'UserManualPaymentList',
  component: () => import( /* webpackChunkName: "Billing" */ '../views/billing/ManualPaymentList.vue'),
  meta: {
    title: 'Konfirmasi Transfer Manual',
    auth: true,
    role: ['admin', 'user', 'agency', 'user-agency'],
  }
},
{
  path: '/admin/ai-token-stats',
  name: 'AdminAITokenStats',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/AITokenStats.vue'),
  meta: {
    title: 'Statistik Token AI',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/ongkir-stats',
  name: 'AdminOngkirStats',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/OngkirStats.vue'),
  meta: {
    title: 'Statistik Hit Ongkir',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/google-auth',
  name: 'AdminGoogleAuth',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/AdminGoogleAuth.vue'),
  meta: {
    title: 'Login Google',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/message-template/edit',
  name: 'EditMessageTemplate',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/EditMessageTemplate.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/messages',
  name: 'MessagesUser',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/MessagesUser.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/withdraw',
  name: 'Withdraw',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Withdraw.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/coupon',
  name: 'Coupon',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Coupon.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/coupon/edit',
  name: 'EditCoupon',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/EditCoupon.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/simulator',
  name: 'Simulator',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Simulator.vue'),
  meta: {
    title: 'Simulator',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/node-server',
  name: 'NodeServer',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/NodeServer.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/node-server/edit',
  name: 'EditNodeServer',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/EditNodeServer.vue'),
  meta: {
    title: 'Admin Page',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/node-server-monitoring',
  name: 'NodeServerMonitoring',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/NodeServerMonitoring.vue'),
  meta: {
    title: 'Node Server Monitoring',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/domain-monitoring',
  name: 'MonitoredEndpointMonitoring',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/MonitoredEndpointMonitoring.vue'),
  meta: {
    title: 'Domain Monitoring',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/server-monitor',
  name: 'AdminServerMonitor',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/AdminServerMonitor.vue'),
  meta: {
    title: 'Server Resource Monitor',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/expired-accounts',
  name: 'AdminExpiredAccounts',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/ExpiredAccounts.vue'),
  meta: {
    title: 'Akun Expired',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/expiry-reminders',
  name: 'AdminExpiryReminders',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/ExpiryReminderLog.vue'),
  meta: {
    title: 'Log Reminder Email Expired',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},
{
  path: '/admin/generate-invoice',
  name: 'AdminGenerateInvoice',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/GenerateInvoice.vue'),
  meta: { title: 'Generate Invoice User', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/revenue',
  name: 'AdminRevenue',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Revenue.vue'),
  meta: { title: 'Pendapatan Admin', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/scalev-report',
  name: 'AdminScalevReport',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/ScalevReport.vue'),
  meta: { title: 'Laporan Scalev', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/passkey-report',
  name: 'AdminPasskeyReport',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/PasskeyReport.vue'),
  meta: { title: 'Laporan Passkey', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/463-report',
  name: 'AdminReport463',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/Report463.vue'),
  meta: { title: 'Laporan 463', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/public-orders',
  name: 'AdminPublicOrders',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/PublicOrderReport.vue'),
  meta: { title: 'Laporan Order Publik', auth: true, role: ['admin'], expiredGuard: true }
},
{
  path: '/admin/welcome-emails',
  name: 'AdminWelcomeEmails',
  component: () => import( /* webpackChunkName: "Admin" */ '../views/admin/WelcomeEmailLog.vue'),
  meta: {
    title: 'Log Welcome Email',
    auth: true,
    role: ['admin'],
    expiredGuard: true,
  }
},

//CUSTOMER SERVICE
{
  path: '/cs-page/dashboard',
  name: 'DashboardCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/Dashboard.vue'),
  meta: {
    title: 'Dashboard',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/web-whatsapp',
  name: 'WebWhatsappCustomerServiceSelectDevice',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/WebWhatsappSelectDevice.vue'),
  meta: {
    title: 'Web Whatsapp',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/web-whatsapp/:id',
  name: 'WebWhatsappCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/Chat.vue'),
  meta: {
    title: 'Web Whatsapp',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/order',
  name: 'OrderCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/order/Index.vue'),
  meta: {
    title: 'Order',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/order/follow-up',
  name: 'OrderCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/order/FollowUp.vue'),
  meta: {
    title: 'Order',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/kategori',
  name: 'KategoriCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/category/Index.vue'),
  meta: {
    title: 'Kategori',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/kategori/detail',
  name: 'KategoriCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/category/Detail.vue'),
  meta: {
    title: 'Kategori',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/autotext',
  name: 'AutotextCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/autotext/Index.vue'),
  meta: {
    title: 'Autotext',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/autotext/detail',
  name: 'AutotextCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/autotext/Detail.vue'),
  meta: {
    title: 'Autotext',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/toko',
  name: 'TokoCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/toko/Index.vue'),
  meta: {
    title: 'Toko',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/cs-page/toko/detail',
  name: 'TokoCustomerService',
  component: () => import( /* webpackChunkName: "CustomerService" */ '../views/customer-service/toko/Detail.vue'),
  meta: {
    title: 'Toko',
    auth: true,
    role: ['customer_service']
  }
},
{
  path: '/syarat_ketentuan',
  name: 'SyaratKetentuan',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/SyaratKetentuan.vue'),
  meta: {
    title: 'Syarat dan Ketentuan',
    auth: false
  }
},
{
  path: '/banned',
  name: 'Banned',
  component: () => import( /* webpackChunkName: "Auth" */ '../views/auth/Banned.vue'),
  meta: {
    title: 'Banned',
    auth: false
  }
},

    {
        path: '/support',
        name: 'MySupportTickets',
        component: () => import( /* webpackChunkName: "Support" */ '../views/support/MyTickets.vue'),
        meta: { title: 'Tiket Support', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: false }
    },
    {
        path: '/support/ticket/:id',
        name: 'SupportTicketDetail',
        component: () => import( /* webpackChunkName: "Support" */ '../views/support/TicketDetail.vue'),
        meta: { title: 'Detail Tiket', auth: true, role: ['admin', 'user', 'agency', 'user-agency'], expiredGuard: false }
    },
    {
        path: '/admin/support-tickets',
        name: 'AdminSupportTickets',
        component: () => import( /* webpackChunkName: "Support" */ '../views/admin/SupportTickets.vue'),
        meta: { title: 'Support Tickets (Admin)', auth: true, role: ['admin'], expiredGuard: false }
    },
    {
        path: '/admin/support-tickets/:id',
        name: 'AdminSupportTicketDetail',
        component: () => import( /* webpackChunkName: "Support" */ '../views/admin/SupportTicketDetail.vue'),
        meta: { title: 'Tiket Detail (Admin)', auth: true, role: ['admin'], expiredGuard: false }
    },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/** Halaman checkout publik — user login tetap boleh buka (jangan redirect ke dashboard). */
function guestPathAllowedWhenLoggedIn(path) {
  return path === '/order' || path.startsWith('/order/')
}

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem('token')) {
    const jwtPayload = parseJwt(localStorage.token);
    if (jwtPayload.exp < Date.now() / 1000) {
      console.log("expired")
      store.dispatch("auth_logout")
      localStorage.removeItem('role')
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('socket_token')
      return next({ path: "/login", replace: true })
    }

    if (localStorage.getItem('role') != "customer_service") {

      let detail = await store.dispatch("user_detail_status")
      const userStatus = detail.data.data.user_status
      // const userStatus = 2

      if (userStatus == 0) {
        store.dispatch("auth_logout")
        localStorage.removeItem('role')
        localStorage.removeItem('token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('socket_token')
        return next({ path: "/login", replace: true })
      }

      if (userStatus == 2) {
        if (to.path !== "/banned") {
          store.dispatch("auth_logout")
          localStorage.removeItem('role')
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('socket_token')
          return next({ path: "/banned", replace: true })
        } else {
          return next() // biar berhenti looping
        }
      }
    }

  }

  if (to.matched.some(record => record.meta.auth) == "all") {
    next()
  } else if (
    !to.matched.some(record => record.meta.auth) &&
    !to.matched.some(record => record.meta.public) &&
    !guestPathAllowedWhenLoggedIn(to.path) &&
    store.state.auth.isLoggedIn
  ) {
    next("/dashboard")
  } else if (to.matched.some(record => record.meta.auth) && !store.state.auth.isLoggedIn) {
    return next({ path: "/login", replace: true })
  } else {
    next()
  }
});

// Cache untuk menghindari terlalu banyak request
let lastPackageRefresh = 0
const PACKAGE_REFRESH_INTERVAL = 30000 // 30 detik

function packageExpiredAtMs(pkg) {
  if (!pkg || pkg.expired_at == null || pkg.expired_at === '') return null
  const t = pkg.expired_at
  if (typeof t === 'number') return t
  if (typeof t === 'string') {
    const n = Number(t)
    return Number.isFinite(n) ? n : null
  }
  return null
}

function isPackageExpired(pkg) {
  const exp = packageExpiredAtMs(pkg)
  if (exp == null) return false
  return exp < Date.now()
}

async function pullLatestPackage(force) {
  const now = Date.now()
  if (!force && (now - lastPackageRefresh) <= PACKAGE_REFRESH_INTERVAL) {
    return
  }
  try {
    const userDetail = await store.dispatch('user_detail')
    const pkg = userDetail?.data?.data?.package_data
    if (pkg) {
      store.commit('auth/SET_PACKAGE', pkg)
      lastPackageRefresh = now
    }
  } catch (err) {
    console.error('Failed to refresh package data in router:', err)
  }
}

router.beforeEach(async (to, from, next) => {
  if (store.state.auth.isLoggedIn && localStorage.getItem('role') != "customer_service") {
    if (to.path === "/billing" || to.path.startsWith("/billing/") || to.path === "/order" || to.path.startsWith("/order/")) {
      return next()
    }

    const needsExpiredGuard = to.matched.some(record => record.meta.expiredGuard)
    let packageJustUpdated = false
    try {
      packageJustUpdated = sessionStorage.getItem('ss_package_fresh') === '1'
    } catch (e) { /* noop */ }

    if (needsExpiredGuard || packageJustUpdated) {
      await pullLatestPackage(true)
      if (packageJustUpdated) {
        try { sessionStorage.removeItem('ss_package_fresh') } catch (e) { /* noop */ }
      }
    } else {
      await pullLatestPackage(false)
    }

    if (isPackageExpired(store.state.auth.package)) {
      if (needsExpiredGuard) {
        // Race setelah top up / beli paket (webhook atau commit DB)
        await new Promise(resolve => setTimeout(resolve, 700))
        lastPackageRefresh = 0
        await pullLatestPackage(true)
        if (isPackageExpired(store.state.auth.package)) {
          return next({ path: "/billing", replace: true })
        }
      }
    }

    return next()
  }
  return next()
})


//CHECK ROLE
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth) && store.state.auth.isLoggedIn) {
    if (localStorage.getItem('role')) {
      let myRole = localStorage.getItem('role')
      let role = to.meta.role

      //FIND ROLE
      for (let i = 0; i < role.length; i++) {
        if (role[i] == myRole) {
          next()
          return
        }
      }

      console.log("invalid")
      store.dispatch("auth_logout")
      localStorage.removeItem('role')
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('socket_token')
      return next({ path: "/login", replace: true })
    } else {
      console.log("invalid")
      store.dispatch("auth_logout")
      localStorage.removeItem('role')
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('socket_token')
      return next({ path: "/login", replace: true })
    }
  } else {
    next()
  }
});

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export default router
